//export const AGORA_APP_ID = '4b88772b431645288736acca1a8dd087';
//export const AGORA_APP_ID = '0d2e001d3da542f5954c7d9564a13e7f';
//export const AGORA_APP_ID = 'cec288a5c4d7419e8ab0e5c739dbbd9d';
export const AGORA_APP_ID = '605f401455444442838e00cb859c037b';